import React from 'react';
import { ChevronDownIcon, MoreVerticalIcon, StarIcon } from 'lucide-react';
import { REVIEWS } from '../data/content';
const SUBJECTS = ['This finally feels like a real coaching business', 'My classes are no longer improvised', 'The templates saved me a ton of time', 'I can finally see who needs follow-up'];
export function EmailReviews() {
  return <section className="email-reviews mx-auto mt-6 max-w-md" aria-label="Coach feedback" data-id="element-75" data-mp="19jo8jvf7nm0b">
      <div className="mb-3 flex items-center justify-between px-1" data-id="element-76" data-mp="gxczrxhgaesf">
        <p className="text-xs font-700 uppercase tracking-widest text-white/70" data-id="element-77" data-mp="gxmo7gmukdw0">
          Coach Feedback
        </p>
        <p className="text-xs text-white/50" data-id="element-78" data-mp="luliq0afamuq">Swipe to read</p>
      </div>

      <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="region" aria-label="Coach feedback carousel" data-id="element-79" data-mp="qoptkumt7f13">
        {REVIEWS.map((review, index) => <article key={review.name} className="w-[92%] shrink-0 snap-center rounded-lg border border-[#dadce0] bg-white p-4 text-left" data-id="element-80" data-mp="26jovpv1l6liu" data-mpi={index}>
            <div className="flex items-start gap-3" data-id="element-81" data-mp="1wtceocszdahg">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#1a73e8] text-sm font-700 text-white" data-id="element-82" data-mp="1ws19c8jvzuo8">
                {review.name.charAt(0)}
              </div>

              <div className="min-w-0 flex-1" data-id="element-83" data-mp="1ntfizr86bbcw">
                <div className="flex items-start justify-between gap-3" data-id="element-84" data-mp="1itkt9r04wrtf">
                  <div className="min-w-0" data-id="element-85" data-mp="1is9te29t847l">
                    <p className="truncate text-sm font-700 text-[#202124]" data-id="element-86" data-mp="1dtyhzn3v9ln9">
                      {review.name}
                    </p>
                    <p className="mt-0.5 flex items-center gap-0.5 text-xs text-[#5f6368]" data-id="element-87" data-mp="18wy974fmu4sg">
                      to you <ChevronDownIcon size={13} aria-hidden data-id="element-88" data-mp="387zei1by1wk6" />
                    </p>
                  </div>
                  <div className="flex items-center gap-2 text-[#5f6368]" data-id="element-89" data-mp="33a7m767e08fg">
                    <span className="text-xs" data-id="element-90" data-mp="11jgwur6k5phv">Feedback</span>
                    <MoreVerticalIcon size={17} aria-hidden data-id="element-91" data-mp="16ap7fqjmjgwm" />
                  </div>
                </div>

                <p className="mt-4 text-sm font-700 leading-snug text-[#202124]" data-id="element-92" data-mp="rmky3d6gohqi">
                  {SUBJECTS[index]}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-[#3c4043]" data-id="element-93" data-mp="wlxh1mu7p4nt">
                  {review.text}
                </p>
                <p className="mt-4 text-xs text-[#5f6368]" data-id="element-94" data-mp="1k8nmky5rrhd6">{review.city}</p>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-[var(--pb-lime)]/35 bg-[#132033] px-4 py-2 text-center text-xs font-800 text-white" data-id="element-95" data-mp="1b90ha19x5reu">
        <span data-id="element-96" data-mp="3vz7ylsnvonnw">+450 Pickleball Coaches</span>
        <span aria-hidden className="text-white/35" data-id="element-97" data-mp="3w2dqffnw63nb">•</span>
        <span className="inline-flex items-center gap-0.5 text-yellow-300" data-id="element-98" data-mp="3xjnpke2iwil">
          5 Stars <StarIcon size={13} className="fill-current" aria-hidden data-id="element-99" data-mp="3shk8q3mew1i0" />
        </span>
        <span aria-hidden className="text-white/35" data-id="element-100" data-mp="3njiovgh5vy5h">•</span>
        <span className="text-[var(--pb-lime)]" data-id="element-101" data-mp="3nj0j9t8m07kw">4.9/5</span>
      </div>
    </section>;
}